import React from 'react';
import Image from 'next/image';
import Title from '@/components/Title';
import { useTranslation } from 'next-i18next';
import LeadButton from '@/components/LeadButton';

const Index = () => {
  const { t } = useTranslation('whyWukong');
  return (
    <section className="container mt-20 lg:mt-[140px] xl:mt-[180px]">
      <Title className="" innerHTML theme="colorful">
        {t('理由-服务-标题')}
      </Title>
      <p className="subTitleMaxWidth mt-6 text-center text-base leading-normal text-wk-words-1 lg:text-xl xl:text-[28px] xl:leading-[46px]">
        {t('理由-服务-介绍')}
      </p>
      <div className="relative mt-6 lg:mt-[84px] xl:mt-[134px]">
        <div className="relative mx-auto h-[146px] w-full rounded-3xl border-[3px]  border-white shadow-[0px_3.98px_9.95px_0px_rgba(0,0,0,0.04)] lg:h-80 lg:w-[735px] lg:rounded-[33.5px] lg:border-[6px] lg:shadow-[0px_8.727px_21.818px_0px_rgba(0,0,0,0.04)] xl:h-[440px] xl:w-[1010px] xl:rounded-[46px] xl:border-8 xl:shadow-[0px_12px_30px_0px_rgba(0,0,0,0.04)]">
          <video
            className="video1  block h-full w-full  rounded-xl object-cover  lg:rounded-[27px] xl:rounded-5xl"
            src="https://cdnwukong.com/images/growth/video/child.mp4"
            controlsList="nodownload, nofullscreen"
            playsInline
            x5-video-player-fullscreen="false"
            x5-playsinline="true"
            webkit-playsinline="true"
            loop
            autoPlay
            muted
            poster="/images/reasonsForChoosing/service/child.jpeg"
          />
          <div className="absolute -left-[98px] -top-[60px] hidden lg:block lg:h-[152px] lg:w-[226px] xl:-left-[148px] xl:-top-[94px] xl:h-[226px] xl:w-[335px]">
            <Image
              src="/images/reasonsForChoosing/service/study.png"
              layout="responsive"
              width={0}
              height={0}
              alt="study"
            />
          </div>
        </div>
        <div className="video2  absolute -bottom-11 right-5  box-border h-[84px] w-[108px] rounded-xl border-[3px] border-white bg-white   shadow-[0px_3.6px_9px_0px_rgba(0,0,0,0.04)] lg:-bottom-10 lg:right-0 lg:h-[210px] lg:w-[270px] lg:rounded-[34.5px] lg:border-[6px] lg:shadow-[0px_9px_22.5px_0px_rgba(0,0,0,0.04)] xl:-bottom-[53px] xl:h-[280px] xl:w-[360px] xl:rounded-[46px] xl:border-8 xl:shadow-[0px_12px_30px_0px_rgba(0,0,0,0.04)]">
          <video
            className="block h-full w-full rounded-[10px] object-cover lg:rounded-[28px]  xl:rounded-[40px]"
            src="https://cdnwukong.com/images/growth/video/why-wukong-service-teacher.mp4"
            controlsList="nodownload, nofullscreen"
            playsInline
            x5-video-player-fullscreen="false"
            x5-playsinline="true"
            webkit-playsinline="true"
            loop
            autoPlay
            muted
            poster="/images/reasonsForChoosing/service/teacher.png"
          />
        </div>
      </div>
      <div className="mt-15 text-center lg:-mt-[33px]">
        <LeadButton
          theme="colorfulBorder"
          size="xl"
          traceName="O_WhyWuKong_ServiceAdvantage_CTAClick"
          traceGa4Name="new_entry_How_ServiceAdvantageCTA"
        >
          {t('理由-服务-加入学习')}
        </LeadButton>
      </div>
    </section>
  );
};

export default Index;
